import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ppl-two-factor-method-setup-step',
    templateUrl: './two-factor-method-setup-step.component.html',
    styleUrls: ['./two-factor-method-setup-step.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TwoFactorMethodSetupStepComponent {

  @Input() title: string;
  @Input() description?: string;
  @Input() infoMessage?: string;
  @Input() showDescription = true;

  constructor() { }
}
